<div style=" display: inline;block-size: 10%;">

    <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder " style="padding-right: 0px;">

        <div class="col-md-6" style="display: inline-block;">

            <h2 style="margin-top:2%; ;margin-left: -11px;float: left;" class=" ng-binding">
                Consumption Analysis
            </h2>

        </div>

        <div class="col-md-6" style="display: inline-block; text-align: right;">
            <span class="btn-blue" style="font-size: 13px; display: inline-block; padding: 4px 12px 4px; font-size: 15px; margin-left: 10px; position: relative; bottom: 15px;" (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
              </span>
        </div>
        <!--   
      <div class="col-md-6" style="display: inline-block;position: relative;
      top: -13px;    padding: 0px; ">
        <span class="btn btn-yellow fntSz" (click)="exportToExcel()" title="Export to Excel"
          style="cursor:pointer;margin-left: 10px;line-height: 23px; float: right;padding: 5px 11px;"><span><i
              class="fa fa-file-excel-o" aria-hidden="true"></i></span></span>
      </div> -->
    </div>
</div>


<!-- <div class="col-md-12 col-xs-12 col-sm-12 " style="margin-bottom: 10px;"> -->

<div class="col-md-8 col-12 col-sm-12 pad0 bgWhite  "
    style="padding-top: 10px;padding-bottom: 0px;padding-right: 30px; padding-left: 15px; display: inline-block;">
    <span class="label orangeBadge fntSz {{filter == 0 ? 'activeOrange' : ''}}" (click)="typeFilter(0)"
        style="cursor:pointer;margin-left:0px;"><span>Today</span></span>
    <span class="label yellowBadge fntSz {{filter == 1 ? 'activeYellow' : ''}}" (click)="typeFilter(1)"
        style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
                aria-hidden="true"></i></span> <span>Yesterday</span></span>
    <span class="label greenBadge fntSz {{filter == 2 ? 'activeGreen' : ''}}" (click)="typeFilter(2)"
        style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
                aria-hidden="true"></i></span> <span>Last 7 days</span></span>
    <span class="label blueBadge fntSz {{filter == 3 ? 'activeBlue' : ''}}" (click)="typeFilter(3)"
        style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
                aria-hidden="true"></i></span> <span>Last 30 Days</span></span>
    <span class="label brownBadge fntSz {{filter == 4 ? 'activeBrown' : ''}}" (click)="typeFilter(4)"
        style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
                aria-hidden="true"></i></span> <span>Other</span></span>
    <select required="" class="mrgnLeft10 form-control " style="width:125px;margin-left:5px;display: inline-block;"
        placeholder="Select Category">

        <option value="0" disabled="" selected="" hidden="">Select Month</option>
        <option id="select" value="2" class="ng-binding ng-scope">June 2012</option>
        <option id="select" value="3" class="ng-binding ng-scope">May 2019</option>
        <option id="select" value="4" class="ng-binding ng-scope">Jan 2020</option>
        <option id="select" value="5" class="ng-binding ng-scope">June 2022</option>
    </select>
</div>

<div class="col-md-4 col-xs-4 col-sm-4 pad15" style="display: inline-block;">

    <select required="" class="mrgnLeft10 form-control " style="margin-left:0px;width: 104%;"
        placeholder="Select Product">
        <option value="0" disabled="" selected="" hidden="">Select Product</option>
        <option id="select" value="2" class="ng-binding ng-scope">Electronics</option>
        <option id="select" value="3" class="ng-binding ng-scope">Eng.</option>
        <option id="select" value="4" class="ng-binding ng-scope">Food</option>
        <option id="select" value="5" class="ng-binding ng-scope">Furniture</option>
    </select>
    <!-- <input type="text" class="autoselect" placeholder="Prefered Supplier" aria-label="Number" matInput
      [matAutocomplete]="auto">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"> -->
    <!-- <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{option}}
      </mat-option> -->
    <!-- </mat-autocomplete> -->
</div>


<div class="col-md-12 col-xs-12 col-sm-12" style="padding-right: 0px;padding-top: 20px; ">
    <label>Production:</label>
    <div style=" text-overflow: ellipsis;">
        <table mat-table [dataSource]="dataSource" style="margin-top:20px">
            <ng-container matColumnDef="production">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Production</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.production}} </td>
            </ng-container>

            <ng-container matColumnDef="category">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label> Category</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.category}} </td>
            </ng-container>

            <ng-container matColumnDef="qty">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Qty</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.qty}} </td>
            </ng-container>

            <ng-container matColumnDef="unit">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Unit</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.unit}} </td>
            </ng-container>

            <ng-container matColumnDef="value">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Value</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.value}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <!-- Angular 8 pagination -->
        <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
        </mat-paginator>
    </div>
</div>



<div class="col-md-12 col-xs-12 col-sm-12" style="padding-right: 0px;padding-top: 20px; ">
    <label>Consumption : </label>
    <div style=" text-overflow: ellipsis;">
        <table mat-table [dataSource]="dataSource1" style="margin-top:20px">
            <ng-container matColumnDef="material">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Material</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.material}} </td>
            </ng-container>

            <ng-container matColumnDef="category">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label> Category</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.category}} </td>
            </ng-container>

            <ng-container matColumnDef="expected">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label> Expected</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.expected}} </td>
            </ng-container>

            <ng-container matColumnDef="materialissue">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Materialissue</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.materialissue}} </td>
            </ng-container>

            <ng-container matColumnDef="unit">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Unit</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.unit}} </td>
            </ng-container>

            <ng-container matColumnDef="excess">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Excess</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.excess}} </td>
            </ng-container>

            <ng-container matColumnDef="expcost">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Expcost</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.expcost}} </td>
            </ng-container>

            <ng-container matColumnDef="actcost">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef>
                    <label>Actcost</label>
                </th>
                <td><input type="text"></td>
                <td mat-cell *matCellDef="let element"> {{element.actcost}} </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
        </table>
        <!-- Angular 8 pagination -->
        <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
        </mat-paginator>
    </div>
</div>